<template>
    <div>
        <van-overlay :show="show" z-index='1000' @click="show = false" >
            <div class="wrapper">
                <div class="block">
                    <video-player
                        ref="videoPlayer"
                        class="video-player vjs-custom-skin"
                        :playsinline="true"
                        :options="playerOptions"
                    />
                </div>
            </div>
        </van-overlay>
    </div>
</template>
<script>
    import { videoPlayer } from 'vue-video-player'
    import 'vue-video-player/src/custom-theme.css'
    import 'video.js/dist/video-js.css'
    export default {
        name:"MediaPlayer",
        components: {
            videoPlayer
        },
        data() {
            return {
                show:false,
                // 视频播放
                playerOptions: {
                    playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
                    autoplay: false, // 如果true,浏览器准备好时开始回放。
                    muted: false, // 默认情况下将会消除任何音频。
                    loop: false, // 导致视频一结束就重新开始。
                    preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    language: 'zh-CN',
                    aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    sources: [{
                        type: "video/mp4", // 类型
                        src: ''// url地址
                    }],
                    // poster: '../asset/play.png', // 你的封面地址
                    notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    controlBar: {
                        timeDivider: true,
                        durationDisplay: true,
                        remainingTimeDisplay: false,
                        pause: true,
                        fullscreenToggle: true // 全屏按钮
                    }
                },
                PlayerSourceSrc: '' // 视频播放地址
            }
        },
        methods: {
            ShowPlayer(url){
                this.show = true
                this.playerOptions['sources'][0]['src'] = url
          }
        },
        mounted() {

        },
        watch: {
            show(value){
              console.log(value)
            }
        },
    };
</script>

<style lang="less" scoped>
    .wrapper {
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }

    .block {
        width: 100%;
        border-radius: 10px;
        background-color: #fff;
    }
</style>